module.exports = __webpack_public_path__ + "ba37297a7a4cbe99c28ca8afcae67fe8.pdf";